import React, {Component} from 'react';
import CreateYourPassword from '../framework/CreateYourPassword/CreateYourPassword';
import ImgUpload from '../framework/ImgUpload/ImgUpload';
import RoleExplainTip from '../framework/RoleExplainTip/RoleExplainTip';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import InputField from '../framework/InputField/InputField';
import Error from 'material-ui/svg-icons/alert/error';
import MaskedInput from 'react-text-mask';
import {
  buttonBlueColor
} from "../../utils/utility";
// css
import './create-client-account.css';

class CreateClientAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roleName: '',
      requiredFirstNameText: '',
      requiredLastNameText: '',
      requiredEmailText: '',
      requestParams: {
        username: '',
        password: '',
        confirmPassword: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        officePhone: '',
        mobilePhone: ''
      }
    }
  }
  componentDidMount () {
    this.props.logout();

    this.props.getInvitationByCode(this.props.match.params.code);
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.get_invitation_by_code.invitation) {
      const {
        firstName,
        lastName,
        email
      } = nextProps.get_invitation_by_code.invitation;
      this.setState({
        roleName: nextProps.get_invitation_by_code.invitation.role.name,
        requestParams: {
          ...this.state.requestParams,
          firstName,
          lastName,
          email
        }
      })
    }
  }
  handleFirstName (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        firstName: value
      }
    })
  }
  handleLastName (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        lastName: value
      }
    })
  }
  handleEmail (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value
      }
    })
  }

  getUploadJson (json) {
    json.then((json) => {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          companyLogoUuid: json.uuid
        }
      })
    })
  }

  newPasswordOnChange (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        password: value
      }
    })
  }
  confirmPasswordOnChange (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        confirmPassword: value
      }
    })
  }
  handleTitle (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        title: value
      }
    })
  }
  handleUsername (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        username: value
      }
    })
  }
  handleMobilePhone (e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        mobilePhone: e.target.value
      }
    })
  }
  handleOfficePhone (e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        officePhone: e.target.value
      }
    })
  }
  getUploadPhotoJson (json) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        avatar: json.name
      }
    })
  }
  handleRegister () {
    // if register for business unit memeber
    const isInviteBusinessMember = /^\/create-business-unit-member-account/gi.test(this.props.location.pathname);
    if (this.state.requestParams.firstName.trim().length === 0) {
      this.setState({
        requiredFirstNameText: 'Please enter your first name'
      })
    } else {
      this.setState({
        requiredFirstNameText: ''
      })
    }
    if (this.state.requestParams.lastName.trim().length === 0) {
      this.setState({
        requiredLastNameText: 'Please enter your last name'
      })
    } else {
      this.setState({
        requiredLastNameText: ''
      })
    }
    if (this.state.requestParams.email.trim().length === 0) {
      this.setState({
        requiredEmailText: 'Please enter your email'
      })
    } else {
      this.setState({
        requiredEmailText: ''
      })
    }
    if (this.state.requestParams.firstName.trim().length > 0 && this.state.requestParams.lastName.trim().length > 0 && this.state.requestParams.email.trim().length > 0) {
      isInviteBusinessMember ?
        this.props.register(this.props.match.params.code, this.state.requestParams, 'businessUnitMemberRegister') :
        this.props.register(this.props.match.params.code, this.state.requestParams, 'clientRegister');
    }
  }
  render () {
    const isInviteBusinessMember = /^\/create-business-unit-member-account/gi.test(this.props.location.pathname);
    return (
      <MuiThemeProvider>
        <div className="create-client-account">
          {
            this.props.invitation_error_message !== '' && (
              <div className="create-account-success" style={{width: '100%', border: 'none'}}>
                <p style={{fontSize: '16px', color: 'black', fontWeight: 'bolder', padding: '25px 0', textAlign: 'center'}}>{this.props.invitation_error_message}</p>
                <div style={{textAlign: 'center'}} className="btn-wrapper">
                  <a href="/login" style={{height: '30px', padding: '0 10px', background: buttonBlueColor(), color: 'white', border: 'none'}}>CLOSE</a>
                </div>
              </div>
            )
          }
          {
            this.props.ifRegisterSuccess && (
              <div className="create-account-success" style={{margin: '2em auto 3em'}}>
                <p>Your have successfully created your profile</p>
                <div className="btn-wrapper">
                  <a href="/login">LOGIN</a>
                </div>
              </div>
            )
          }
          {
            (!this.props.ifRegisterSuccess && this.props.invitation_error_message === '') && (
              <div className="create-client-wrapper">
                <div className="create-client-account-field-wrapper">
                  <h2>MY PROFILE</h2>
                  <div className="client-name">
                    <strong>{isInviteBusinessMember ? 'Business Unit Name' : 'Client Name'}</strong>
                    <span>{typeof this.props.get_invitation_by_code.invitation !== 'undefined' && this.props.get_invitation_by_code.invitation.client.name}</span>
                  </div>
                  <div className="explain">
                    <RoleExplainTip
                      role={typeof this.props.get_invitation_by_code.invitation !== 'undefined' && this.props.get_invitation_by_code.invitation.role}
                    />
                  </div>

                  <InputField
                    labelTitle="Title"
                    onChange={(e, value) => this.handleTitle(e, value)}
                    borderColor="black"
                    labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                    inputContainerId="title"
                    style={{height: '32px', lineHeight: '32px', marginBottom: '30px'}}
                  />
                  <InputField
                    labelTitle="First Name"
                    ifRequireField={true}
                    initValue={this.state.requestParams.firstName}
                    hintText={this.state.requestParams.firstName}
                    onChange={(e, value) => this.handleFirstName(e, value)}
                    borderColor="black"
                    labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                    inputContainerId="firstName"
                    style={{height: '32px', lineHeight: '32px', marginBottom: '30px'}}
                  />
                  {
                    this.state.requiredFirstNameText && (
                      <p className="create-account-field-error clearfix">
                        <Error
                          style={{float: 'left'}}
                          color="red"
                        />
                        <span>{this.state.requiredFirstNameText}</span>
                      </p>
                    )
                  }
                  <InputField
                    labelTitle="Last Name"
                    ifRequireField={true}
                    initValue={this.state.requestParams.lastName}
                    hintText={this.state.requestParams.lastName}
                    onChange={(e, value) => this.handleLastName(e, value)}
                    borderColor="black"
                    labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                    inputContainerId="lastName"
                    style={{height: '32px', lineHeight: '32px', marginBottom: '30px'}}
                  />
                  {
                    this.state.requiredLastNameText && (
                      <p className="create-account-field-error clearfix">
                        <Error
                          style={{float: 'left'}}
                          color="red"
                        />
                        <span>{this.state.requiredLastNameText}</span>
                      </p>
                    )
                  }
                  <InputField
                    labelTitle="E-mail Address"
                    ifRequireField={true}
                    initValue={this.state.requestParams.email}
                    hintText={this.state.requestParams.email}
                    onChange={(e, value) => this.handleEmail(e, value)}
                    borderColor="black"
                    labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                    inputContainerId="email"
                    style={{height: '32px', lineHeight: '32px', marginBottom: '30px'}}
                  />
                  {
                    this.state.requiredEmailText && (
                      <p className="create-account-field-error clearfix">
                        <Error
                          style={{float: 'left'}}
                          color="red"
                        />
                        <span>{this.state.requiredEmailText}</span>
                      </p>
                    )
                  }
                  <InputField
                    labelTitle="Username"
                    onChange={(e, value) => this.handleUsername(e, value)}
                    borderColor="black"
                    labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                    inputContainerId="username"
                    style={{height: '32px', lineHeight: '32px', marginBottom: '30px'}}
                  />
                  <div className="profile-mobile-phone-number clearfix" style={{marginBottom: '30px'}}>
                    <span style={{marginTop: this.state.ifHiddenTopEdit ? '' : '10px'}}>
                      Mobile Phone Number
                    </span>
                    <MaskedInput
                      className="mp-mask"
                      guide={false}
                      style={{border: '1px solid black', height: '32px'}}
                      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                      onChange={(e) => this.handleMobilePhone(e)}
                    />
                  </div>
                  <div className="profile-mobile-phone-number clearfix" style={{marginBottom: '30px'}}>
                    <span style={{marginTop: this.state.ifHiddenTopEdit ? '' : '10px'}}>
                      Office Phone Number
                    </span>
                    <MaskedInput
                      className="mp-mask"
                      guide={false}
                      style={{border: '1px solid black', height: '32px'}}
                      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                      onChange={(e) => this.handleOfficePhone(e)}
                    />
                  </div>
                </div>
                {
                  (!/Team Member/gi.test(this.state.roleName) || isInviteBusinessMember) && (
                    <ImgUpload
                      title="Logo"
                      fieldName="logo"
                      buttonLable="UPLOAD LOGO"
                      getUploadJson={(json) => this.getUploadJson(json)}
                      url={`/api/invitations/with/${this.props.match.params.code}/logo/upload`}
                      subTitle="Select a logo to upload"
                    />
                  )
                }

                <ImgUpload
                  title="PROFILE PHOTO"
                  fieldName="avatar"
                  buttonLable="UPLOAD PHOTO"
                  getUploadJson={(json) => this.getUploadPhotoJson(json)}
                  url={`/api/avatars/${this.props.match.params.code}/upload`}
                  subTitle="Select a photo to upload"
                />
                <div className="create-client-account-pw">
                  <CreateYourPassword
                    newPasswordOnChange={(e, value) => this.newPasswordOnChange(e, value)}
                    confirmPasswordOnChange={(e, value) => this.confirmPasswordOnChange(e, value)}
                  />
                </div>
                <div className="btns clearfix">
                  <p style={{float: 'left', color: 'red', lineHeight: '30px', width: '42em'}}>{this.props.error_message}</p>
                  <button onClick={() => this.handleRegister()}>SAVE</button>
                </div>
              </div>
            )
          }
        </div>
      </MuiThemeProvider>
    )
  }
}

export default CreateClientAccount;



// WEBPACK FOOTER //
// ./src/components/CreateClientAccount/Index.jsx